import { NgModule } from '@angular/core';
import { MedicalFeePrePaymentFilterComponent } from '../medical-fee-pre-payment-filter/medical-fee-pre-payment-filter.component';
import { SharedModule } from '../../shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { MedicalFeePrePaymentSearchComponent } from './medical-fee-pre-payment-search.component';

@NgModule({
  declarations: [
    MedicalFeePrePaymentSearchComponent,
    MedicalFeePrePaymentFilterComponent],
  imports: [
    SharedModule,
    ReactiveFormsModule
  ]
})
export class MedicalFeePrePaymentSearchModule { }
